export default __webpack_public_path__ + "f2f48d8e8106e7d9aa27fabefa623849.png";